var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      staticClass: "flex",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSearch.apply(null, arguments)
        },
      },
    },
    [
      _c("Search", {
        staticClass: "w-60",
        attrs: {
          nameSearchStyle: _vm.nameSearchStyle,
          debounceTime: 0,
          placeholderText: `Search by name`,
        },
        on: { change: _vm.onSearch, search: _vm.onSearchUpdate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }